module.exports = __webpack_public_path__ + "static/media/empty-journal.6de604a6.svg";